import { render, staticRenderFns } from "./TrendTheme.vue?vue&type=template&id=3ebb97be&name=trend-theme&"
import script from "./TrendTheme.vue?vue&type=script&lang=js&"
export * from "./TrendTheme.vue?vue&type=script&lang=js&"
import style0 from "./TrendTheme.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports